import { useEffect, useMemo, useState } from 'react'

import { useSelector } from 'react-redux'
import { faMerge, faSave } from '@fortawesome/pro-solid-svg-icons'

import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import IconButton from '../../antd/Buttons/IconButton'
import ConfirmableIconButton from '../../antd/Buttons/ConfirmableIconButton'
import SchoolsList from '../Lists/SchoolsList'
import SchoolCard from './SchoolCard'
import { findSimilarSchools, SchoolProperties } from '../../../utils/entities/school'
import { getIdOrNull, validateString } from '../../../utils'

const { NAME } = SchoolProperties

const SchoolValidator = ({ countries = [], disabled = false, labels, school, schools = [], onMerge, onValidate }) => {
  const t = useSelector(selectTranslate)

  const [selectedSchool, setSelectedSchool] = useState(null)

  const schoolId = getIdOrNull(school)
  const isNamed = validateString(school?.[NAME], { notEmpty: true }).valid

  const duplicate = useMemo(
    () => findSimilarSchools(school, schools).find(existing => existing.id !== schoolId) ?? null,
    [school, schoolId, schools]
  )

  useEffect(() => {
    setSelectedSchool(duplicate?.id ?? null)
  }, [duplicate?.id])

  return (
    <div className='h-100 w-100 flex-row'>
      <div className='flex-column h-100 w-50 mr-8 jc-between'>
        <h3>{t(labels.title)}</h3>
        <SchoolCard countries={countries} school={school} />
        <ConfirmableIconButton
          className='mt-12'
          confirmation={duplicate !== null ? t(labels.duplicate, { schoolName: duplicate[NAME] }) : null}
          disabled={disabled || !isNamed || (!!selectedSchool && selectedSchool !== duplicate?.id)}
          icon={faSave}
          text={t(labels.validate)}
          type='primary'
          onClick={() => onValidate(school)}
        />
      </div>
      <div className='flex-column h-100 w-50'>
        <h3>{t(labels.description)}</h3>
        <SchoolsList
          excluded={schoolId}
          pinned={duplicate?.id}
          schools={schools}
          selected={selectedSchool}
          onSelectedChange={setSelectedSchool}
        />
        <IconButton
          className='mt-12'
          disabled={disabled || !selectedSchool}
          icon={faMerge}
          text={t(labels.merge)}
          type='primary'
          onClick={() => onMerge(schools.find(existing => existing.id === selectedSchool))}
        />
      </div>
    </div>
  )
}

export default SchoolValidator
